import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=681078ba&scoped=true&"
import script from "./breadcrumb.vue?vue&type=script&lang=js&"
export * from "./breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=681078ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681078ba",
  null
  
)

export default component.exports